var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cloudsdaleRadio"},[_c('v-app',{attrs:{"dark":""}},[_c('v-main',[_c('Offline')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }